import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IObeSubmitMetricsRequest, SubmitMetricsResponse } from '@interfaces';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SubmitMetricsService {
  constructor(private http: HttpClient) {}

  callSubmitMetrics(
    submitMetricsData: IObeSubmitMetricsRequest,
  ): Observable<SubmitMetricsResponse> {
    return this.http.post<SubmitMetricsResponse>(`secure/submit-metrics`, submitMetricsData);
  }
}
